import React, { memo } from 'react'

import customConfig from 'customConfig'
import RecordsNotFound from '../shared/recordsNotFound/RecordsNotFound'
import RedeemOption from './RedeemOption'
import CardGridLayout from '../shared/grid/CardGridLayout'

const Redeem = ({
  redeemOptions,
  currentUserPoints,
  onGiftCardSelect,
  tokenProfile: { symbol },
  t
}) => {
  return redeemOptions?.length <= 0 ? (
    <RecordsNotFound
      icon={customConfig.giftCardIcon}
      description={t(customConfig.noRedemptionOptionLabel)}
    />
  ) : (
    <CardGridLayout>
      {redeemOptions?.map((redeemOption, index) => (
        <RedeemOption
          currentUserPoints={currentUserPoints}
          key={index}
          redeemOption={redeemOption}
          tokenSymbol={symbol}
          onClick={() => onGiftCardSelect(redeemOption)}
          t={t}
        />
      ))}
    </CardGridLayout>
  )
}

export default memo(Redeem)
